import { ScrollArea } from "@/components/ui/scroll-area";
import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import TodoCard from "./TodoCard";
import { TodoItem } from "@/types/todo";

interface CategoryCardProps {
  category: {
    name: string;
    icon: LucideIcon;
    color: string;
  };
  todos: TodoItem[];
}

const CategoryCard = ({ category, todos }: CategoryCardProps) => {
  return (
    <Card className="p-6 glass-card">
      <div className="flex items-center gap-3 mb-4">
        <div className={`p-2 rounded-lg ${category.color}`}>
          <category.icon className="h-5 w-5 text-white" />
        </div>
        <h2 className="text-xl font-semibold">{category.name}</h2>
      </div>
      
      <ScrollArea className="h-[400px] pr-4">
        <div className="space-y-4">
          {todos
            .filter(todo => todo.category === category.name)
            .map(todo => (
              <TodoCard key={todo.id} todo={todo} />
            ))}
        </div>
      </ScrollArea>
    </Card>
  );
};

export default CategoryCard;